module.exports = __webpack_public_path__ + "static/1292777576.a809ea66.jpg";